// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { isDarkMode } from '../../provider/types';
import { blue } from '../primitiveColors/blue';
import { common } from '../primitiveColors/common';
import { green } from '../primitiveColors/green';
import { grey } from '../primitiveColors/grey';
import { purple } from '../primitiveColors/purple';
import { red } from '../primitiveColors/red';
import { yellow } from '../primitiveColors/yellow';
var light = {
    primary: grey[900],
    secondary: grey[700],
    tertiary: grey[600],
    disabled: grey[500],
    disabled2: grey[600],
    disabled3: grey[700],
    action: common.white,
    action100: blue[700],
    link: blue[600],
    accent: blue[500],
    black: common.black,
    white: common.white,
    status: {
        error: red[900],
        errorBold: red[500],
        errorAlt: red[700],
        info: blue[700],
        infoBold: blue[500],
        infoAlt: blue[600],
        success: green[900],
        successBold: green[500],
        successAlt: green[700],
        warning: yellow[950],
        warningBold: yellow[600],
        warningAlt: yellow[800],
        special: purple[900],
        specialBold: purple[600],
        specialAlt: purple[700]
    }
};
var dark = {
    primary: grey[50],
    secondary: grey[300],
    tertiary: grey[500],
    disabled: grey[600],
    disabled2: grey[700],
    disabled3: grey[500],
    action: common.black,
    action100: grey[50],
    link: blue[400],
    accent: blue[300],
    black: common.black,
    white: common.white,
    status: {
        error: red[50],
        errorBold: red[400],
        errorAlt: red[300],
        info: blue[50],
        infoBold: blue[400],
        infoAlt: blue[200],
        success: green[100],
        successBold: green[400],
        successAlt: green[300],
        warning: yellow[50],
        warningBold: yellow[400],
        warningAlt: yellow[200],
        special: purple[50],
        specialBold: purple[500],
        specialAlt: purple[300]
    }
};
export var text = function(mode) {
    return isDarkMode(mode) ? dark : light;
};

//# sourceMappingURL=text.js.map